/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { Spinner, SpinnerType, spinnerDefaults } from '../Spinner';
import { LoaderProps } from './Loader.props';

/**
 * SDS Loader component.
 */
export const Loader = (props: LoaderProps): JSX.Element => {
  const { classes, message, type, ...rest } = {
    ...spinnerDefaults,
    ...props,
  };

  const loaderClass = clsx(`sds-loader`, classes);

  return (
    <div className={loaderClass} {...rest}>
      <Spinner type={type as SpinnerType} />
      {message && <div className="sds-loader-message">{message}</div>}
    </div>
  );
};
